import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../authentication/services/auth.guard.service';
import { WebVitalsListComponent } from './components/scripts/webVitalsList.component';



const webVitalsRoutes: Routes = [
 {
    path: 'webvitals', component: WebVitalsListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin','ConfigurationManager']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: WebVitalsListComponent,
            data: { preload: true }
          }
        ]
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(webVitalsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class WebVitalsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/webVitals/WebVitals-routing.module.ts